import { render, staticRenderFns } from "./PhTag.vue?vue&type=template&id=7955b372"
import script from "./PhTag.vue?vue&type=script&lang=js"
export * from "./PhTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports